module.exports = __webpack_public_path__ + "img/mastercard.76d6f523.png";